import { StyleSheet, Dimensions } from 'react-native'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const { width } = Dimensions.get('screen')
const styles = StyleSheet.create({
  overlay: (alpha = 0.3) => ({
    ...StyleSheet.absoluteFillObject,
    backgroundColor: `rgba(46, 60, 39, ${alpha})`,
    borderRadius: 6,
    left: 8,
    right: 8,
    top: 5,
    bottom: 10,
    justifyContent: 'center',
    alignItems: 'center',
  }),
  background: {
    flex: 1,
  },
  container: (bottom) => ({
    flexGrow: 1,
  }),
  scrollContainer: (bottomInset = 0) => {
    return {
      flexGrow: 1,
      paddingBottom: bottomInset + 16,
      paddingHorizontal: '10%'
    }
  },
  contentContainer: {
    flexGrow: 1,
    paddingTop: 20,
    paddingLeft: 10,
  },
  fillRemaining: {
    flexGrow: 1,
    paddingBottom: 80,
  },
  headerContentWrapper: (top = 0) => {
    return {
      // flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      marginTop: 24 + top,
      marginHorizontal: 16,
      marginBottom: 5,
    }
  },
  closeIcon: (color = Colors.white) => {
    return {
      tintColor: color,
    }
  },
  caruselContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  secondaryButton: {
    paddingHorizontal: 20,
    flexGrow: 1,
    flexShrink: 0,
  },

  //pagination
  pagination: {
    flex: 1,
    justifyContent: 'center',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
    marginTop: 5,
  },
  paginationDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    marginHorizontal: 2,
  },
  paginationDotActive: color => ({
    backgroundColor: color,
    width: 10,
    height: 10,
    borderRadius: 5,
  }),
  paginationDotInactive: {
    backgroundColor: Colors.ricePaper,
  },

  //body
  headerRibbon: {
    flex: 1,
  },
  ribbonImageView: {
    marginHorizontal: 25,
    flex: 1,
    justifyContent: 'center',
  },
  ribbonHeaderContent: {
    paddingHorizontal: 20,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: 10,
    flex: 1,
    marginVertical: 40,
    alignItems: 'center',
  },
  lineHeight16: {
    lineHeight: 16,
  },
  lineHeight14: {
    lineHeight: 14,
  },
  middleContent: {
    marginTop: 10,
    marginRight: 25,
  },
  prizesSection: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 20,
    marginBottom: 20,
    marginHorizontal: 16,
  },
  prizesDescription: {
    marginRight: 10,
    flexShrink: 1,
  },
  actionCardWrapper: {
    flex: 1,
    minHeight: 180,
  },
  actionCardImgView: {
    flex: 1,
    justifyContent: 'center',
    marginVertical: 10,
  },
  actionCardContent: {
    paddingHorizontal: 24,
    flex: 1,
    justifyContent: 'center',
    marginVertical: 30,
  },
  actionCardButtons: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  actionCardButton: {
    backgroundColor: Colors.white,
    paddingHorizontal: 7,
    marginRight: 10,
    marginTop: 5,
  },
  rewardsSection: {
    paddingHorizontal: 18,
    marginBottom: 20,
  },
  rewardsWrapper: {
    flex: 1,
    position: 'relative',
    marginBottom: 100,
  },
  gradientCard: {
    borderRadius: 6,
    overflow: 'hidden',
    marginHorizontal: 5,
    transform: [{ translateY: -10 }],
    position: 'relative',
  },
  sideRibbon: {
    position: 'absolute',
    left: 0,
    bottom: -6,
  },
  rewardLoading: {
    position: 'absolute', right: 0, left: 0, top: 0, bottom: 0,
    backgroundColor: 'rgba(46, 60, 39, 0.6)',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 6,
  },
  buttonRightComponent: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 5,
  },
  buttonIcon: color => ({
    marginRight: 5,
    tintColor: color,
  }),
  contentLoaderContainer: {
    flex: 1,
  },
  questionSlideWrapper: {
    backgroundColor: 'white',
    marginHorizontal: 15,
    padding: 7.5,
    borderRadius: 12,
    // height: 500,
    position: 'relative',
    marginBottom: 40,
    // flex: 1,
  },
  gradientBorder: {
    flexGrow: 1,
    margin: 3,
    backgroundColor: Colors.white,
    borderRadius: 3,
    padding: 7.5,
    maxHeight: 375,
    minHeight: 360,
    paddingHorizontal: '10%',
    // overflow: 'hidden',
    // maxHeight: 1200,
    // flex: 1,
  },
  gradientWrapper: {
    borderRadius: 5,
    marginTop: 50,
    flex: 1,
  },
  quizSlideBackground: {
    position: 'absolute',
    top: 5,
    left: -12,
    marginBottom: 40,
    width: 205,
    height: 79,

  },
  radioGroupContainer: {
    marginTop: 20,
    // paddingHorizontal: 35,
    // padding:15,
    // marginBottom: 40,
  },
  quizGameButton: {
    marginHorizontal: 15,
    marginTop: 30,
  },
  quizGameNumber: {
    marginVertical: 20,
    color: Colors.white,
    marginLeft: 35,
  },
  questionSlideHeaderWrapper: {
    flexDirection: 'row',
  },
  questionNumber: {
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    marginTop: 20,
    marginRight: 15,
  },
  timeBar: {
    marginHorizontal: 15,
    marginBottom: 30,
    marginTop: 15,
  },
  quizCardFeedbackWrapper: {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  quizCardFeedbacIcon: {
    marginBottom: 40,
  },
  quizCardFeedbacText: {
    marginVertical: 5,
  },
  // shadow: {
  //   backgroundColor: colors.white,
  //   margin: 16,
  //   padding: 16,
  //   marginTop: 32,
  //   borderRadius: 6,
  //   shadowColor: colors.black,
  //   shadowOffset: { width: 0, height: 2 },
  //   shadowOpacity: 0.16,
  //   shadowRadius: 8,
  //   elevation: 1,
  // }
  //Active Card
  activeCardWrapper: {
    flexGrow: 1,
  },
  levelSelectorHeader: {
    paddingHorizontal: 10,
  },
})

const itemStyles = StyleSheet.create({
  cardContainer: {
    flex: 1,
    width: width - 20,
  },
  card: {
    flexGrow: 1,
    justifyContent: 'space-between',
    position: 'relative',
  },
  cardView: {
    position: 'relative',
  },
  cardHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  headerItemWrapper: {
    alignItems: 'center',
  },
  headerItemTop: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerItemIcon: {
    transform: [{ rotate: '90deg' }],
  },
  emptyHeaderItem: {
    width: 40,
  },
  rowWrapper: {
    flexGrow: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 10,
  },
  rowIconWrapper: (status, color) => ({
    width: 26,
    height: 26,
    borderRadius: 13,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: status === 'suspended' ? color : 'transparent',
  }),
  rowDataWrapper: {
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    marginRight: 25,
  },
  emptyData: {
    width: 95,
  },
  rowElement: {
    width: (width / 3) - 30,
    height: (width / 3) - 30,
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  separatorWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    marginHorizontal: 10,
    marginVertical: 5,
    marginRight: 30,
  },
  separatorBall: {
    width: 4,
    height: 4,
    borderRadius: 2,
    backgroundColor: Colors.cloud,
    marginRight: 5,
  },
  separatorLine: {
    flexGrow: 1,
    height: 1,
    backgroundColor: Colors.cloud,
    borderRadius: 2,
    overflow: 'hidden',
  },
  productInfoLine: {
    flexDirection: 'row',
    marginBottom: 18,
    alignItems: 'center',
  },
  rightSpacing: color => ({
    marginRight: 2,
    tintColor: color,
  }),
  helperView: {
    position: 'absolute',
    backgroundColor: Colors.white,
    padding: 10,
    bottom: 5,
    right: 20,
    borderRadius: 6,
    shadowColor: Colors.black,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.22,
    shadowRadius: 2.22,
    elevation: 3,
  },
})

const modalStyles = StyleSheet.create({
  // Modal non scrollable content
  modalContentContainerWraper: (bottom = 0) => {
    return {
      flexGrow: 1,
      paddingHorizontal: 16,
      paddingVertical: 32,
      paddingBottom: bottom,
    }
  },
  modalContentWraper: {
    flexGrow: 1,
    marginBottom: 32,
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
  verticalSpacing: {
    marginVertical: 16,
  },
  modalAnimIconContainer: {
    width: 120,
    height: 120,
    marginTop: 32,
  },
  modalAnimIcon: {
    flex: 1,
  },
  modalButton: {
    marginBottom: 16,
  },
  lastModalButton: {
    marginBottom: 32,
  },
  headerContentWrapper: (top = 0) => {
    return {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: 24 + top,
      marginHorizontal: 16,
    }
  },
  empty: {
    width: 24,
    height: 24,
  },
  closeIcon: (color = Colors.white) => {
    return {
      tintColor: color,
    }
  },
  //modal
  webView: {
    paddingBottom: 32,
  },
  detailsContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 16,
    paddingTop: 24,
  },
  lottieWrapper: {
    height: '100%',
    paddingHorizontal: 16,
    paddingVertical: 32,
    marginBottom: 32,
    justifyContent: 'center',
    alignItems: 'center',
  },
  lottie: {
    width: 80,
    height: 80,
    marginLeft: 0,
    alignSelf: 'center',
  },
  caruselContent: {
    paddingHorizontal: '10%'
  }
})

export default styles
export { itemStyles, modalStyles }
